import { render, staticRenderFns } from "./EmatInput.vue?vue&type=template&id=450f20b8&"
import script from "./EmatInput.vue?vue&type=script&lang=js&"
export * from "./EmatInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports